/* Lock the page (no scroll, no clicks) while Shopflo's cart/checkout
   drawer is open. We trigger lock by *wrapping* the global functions
   that open the drawer (handleFloCartBtn / handleFloCheckoutBtn) —
   not by passively scanning the DOM, which kept false-positive
   locking on Shopflo's persistent loader iframe.

   Unlock triggers (any one):
     a. The backdrop is clicked.
     b. Esc key.
     c. Polling (every 500ms while locked) detects the drawer iframe
        is no longer in the viewport — covers the case where the
        user closes Shopflo from inside its own UI.
*/
(function () {
  var locked = false;
  var savedY = 0;
  var backdrop = null;
  var poll = null;
  var notOpenCount = 0;

  function lock() {
    if (locked) return;
    locked = true;
    savedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + savedY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';

    backdrop = document.createElement('div');
    backdrop.style.cssText = 'position:fixed;inset:0;background:transparent;z-index:9998;';
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.addEventListener('click', unlock);
    document.body.appendChild(backdrop);

    document.addEventListener('keydown', onEsc, true);

    /* Poll for Shopflo close. Debounced — needs 2 consecutive
       "not open" reads before unlocking, so we don't false-trip
       during the drawer's open animation. */
    notOpenCount = 0;
    if (poll) clearInterval(poll);
    poll = setInterval(function () {
      if (isShopfloDrawerVisible()) {
        notOpenCount = 0;
      } else if (++notOpenCount >= 2) {
        unlock();
      }
    }, 500);
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    window.scrollTo(0, savedY);

    if (backdrop && backdrop.parentNode) {
      backdrop.parentNode.removeChild(backdrop);
    }
    backdrop = null;

    document.removeEventListener('keydown', onEsc, true);

    if (poll) {
      clearInterval(poll);
      poll = null;
    }
  }

  function onEsc(e) {
    if (e.key === 'Escape') unlock();
  }

  function isShopfloDrawerVisible() {
    var iframes = document.getElementsByTagName('iframe');
    for (var i = 0; i < iframes.length; i++) {
      var f = iframes[i];
      var src = f.src || '';
      if (src.indexOf('shopflo') === -1) continue;
      var rect = f.getBoundingClientRect();
      /* Real drawer is large; loader/tracker iframes are tiny. */
      if (rect.width < 200 || rect.height < 200) continue;
      /* Must be inside the viewport, not parked off-screen. */
      if (rect.right < 0 || rect.left >= window.innerWidth) continue;
      if (rect.bottom < 0 || rect.top >= window.innerHeight) continue;
      return true;
    }
    return false;
  }

  /* Patch the global openers as soon as Shopflo's bundle defines
     them. Shopflo loads async, so we retry for up to 20s. */
  var tries = 0;
  function tryPatch() {
    var patched = 0;

    function patchFn(name) {
      if (typeof window[name] !== 'function') return false;
      if (window[name]._lockPatched) return true;
      /* The native cart drawer sets this flag on its own opener (assets/custom-cart.js). It is not a Shopflo drawer */
      if (window[name].isCustomCart) return true;
      var orig = window[name];
      var wrapped = function () {
        lock();
        return orig.apply(this, arguments);
      };
      wrapped._lockPatched = true;
      window[name] = wrapped;
      return true;
    }

    if (patchFn('handleFloCartBtn')) patched++;
    if (patchFn('handleFloCheckoutBtn')) patched++;

    if (patched < 2 && tries++ < 100) {
      setTimeout(tryPatch, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryPatch);
  } else {
    tryPatch();
  }
})();
